import React, { useState } from "react";
import { Button, message } from "antd";
import api from "../../../../services/api";

export const ProcessTrigger = ({ idProcess }) => {
  const [isProcessing, setProcessing] = useState(false);

  const handleProcess = () => {
    setProcessing(true);

    api
      .post(`/contratos/txt/${idProcess}/`, {})
      .then(() => {
        message.info("Processamento iniciado");
      })
      .catch(err => {
        console.error(err);
        message.error("Erro ao processar TXT");
      });
  };

  return (
    <Button
      onClick={handleProcess}
      type={isProcessing ? "ghost" : "primary"}
      loading={isProcessing}
    >
      {isProcessing ? "Processando..." : "Processar"}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/UploadTXT/ProcessTrigger/index.jsx